import React, { useState } from "react";
import { gql } from "apollo-boost";
import { useSubscription } from "@apollo/react-hooks";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Button,
} from "reactstrap";
import { Spinner } from "../../UI/spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { TransactionsRow } from "./TransactionRow";
import { Stars } from "../../UI/Stars";
import { IsErrorOrLoading } from "../utils/IsErrorOrLoading";

const LAST_TEN_TX_SUBSCRIPTION = gql`
  query lastTransactions($offset: Int!, $timestampSortBy: order_by!) {
    transactions_public(
      limit: 10
      offset: $offset
      order_by: { timestamp: $timestampSortBy }
    ) {
      amount
      senderId
      recipientId
      id
      recipient {
        username
      }
      sender {
        username
      }
      transferData
      fee
      timestamp
      type
      sender_tag {
        tag
      }
      recipient_tag {
        tag
      }
    }
  }
`;

export const Transactions: React.FC = () => {
  const limit = 10;
  const [offset, setOffset] = useState(0);
  const [timestampSortBy, setTimestampSortBy] = useState<"desc" | "asc">(
    "desc"
  );
  const icon = timestampSortBy === "desc" ? "caret-down" : "caret-up";
  const toggleTimestampSort = () =>
    setTimestampSortBy(timestampSortBy === "desc" ? "asc" : "desc");
  const { data, loading, error } = useSubscription(LAST_TEN_TX_SUBSCRIPTION, {
    variables: {
      offset,
      timestampSortBy,
    },
  });

  if (error || loading) {
    return (
      <div className="content">
        <IsErrorOrLoading error={!!error} title={"transactions"} />
      </div>
    );
  }

  return (
    <>
      <Stars />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 className="title">Transactions</h5>
              </CardHeader>
              <CardBody className="all-icons">
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>ID</th>
                      <th>
                        <a onClick={toggleTimestampSort}>
                          Date <FontAwesomeIcon icon={icon} />
                        </a>
                      </th>
                      <th>From</th>
                      <th>To</th>
                      <th className="text-center">Amount</th>
                      <th className="text-center">Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <TransactionsRow transactions={data.transactions_public} />
                  </tbody>
                </Table>
                <Row>
                  <Col md="3">
                    {offset >= limit ? (
                      <Button
                        block
                        color="primary"
                        onClick={() => setOffset(offset - limit)}
                      >
                        Previous page
                      </Button>
                    ) : null}
                  </Col>
                  <Col md="6" />
                  <Col md="3">
                    <Button
                      block
                      color="primary"
                      onClick={() => setOffset(offset + limit)}
                    >
                      Next page
                    </Button>
                  </Col>
                </Row>
                <ReactTooltip />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
